import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Strings from './setup.js'

Vue.use(VueI18n)

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'it', // set locale
    messages: Strings,
})

export default i18n